// Staging build for stage.boloarena.com.
//
// Same optimised output as production, pointed at the playmeter-dev Firebase
// project. Kept separate from environment.development.ts so `ng serve` and the
// deployed staging site can diverge later without disturbing each other.
export const environment = {
  /** Shown in the environment banner; PROD hides it. */
  envName: 'STAGING',

  production: false,
  staging: true,
  firebase: {
    apiKey: 'AIzaSyC7GELzpvRVPJfKw8H_bZSDmzp1fqmkUng',
    authDomain: 'playmeter-dev.firebaseapp.com',
    projectId: 'playmeter-dev',
    storageBucket: 'playmeter-dev.firebasestorage.app',
    messagingSenderId: '330980491582',
    appId: '1:330980491582:web:01498bc3826607c20b6c6f',
    measurementId: 'G-05E54LBP3D',
  },
};
